module.exports = __webpack_public_path__ + "logo.172d4e45eb69f3ffc128.png";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/roche/roche/src/img/logo.png
// module id = ../../../../../src/img/logo.png
// module chunks = auth.module styles